var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-0 right-0 -mt-8 px-3"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }